import { AppState } from 'pages';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  boardState,
  BoardStatus,
  setAlertMessage,
  setDeleteIndex,
  setCancelIndex,
  setStatus,
  setCheckIndex
} from 'common/modules/app/board';
import { loadCookie, SasCookieKeys } from 'common/utils/cookie-utils';
import CompletionBoard from '../components/CompletionBoard';
import { FetchState, FetchStatus } from 'common/modules/app/fetch';
import {
  DELETE_LENDING_USER_ID,
  getLendingUserList,
  resetLendingUser
} from 'common/modules/domain/lendingUser';
import { POST_INDIVIDUAL_CANCEL } from 'common/modules/domain/purchase';
import { Glossary } from 'common/utils/glossary';
import { GlossaryState } from 'common/modules/app/glossaries';

export enum ActionType {
  // 登録
  REGISTER = 1,
  // 個別解約
  INDIVIDUAL_CANCEL = 2,
  // レンタル削除
  RELEASE = 3
}

/**
 * StoreのStateからComponentに渡すPropsへ
 */
const useStateProps = () => {
  const boardState = useSelector<AppState, boardState>(
    (state) => state.app.board
  );
  const fetchState = useSelector<AppState, FetchState>(
    (state) => state.app.fetch
  );
  const glState = useSelector<AppState, GlossaryState>(
    (state) => state.app.glossaries
  );
  const actionType =
    boardState.status === BoardStatus.COMPLETION_ADD_LENDING_USER_DISP
      ? ActionType.REGISTER
      : boardState.status === BoardStatus.COMPLETION_DELETE_LENDING_USER_DISP
      ? ActionType.RELEASE
      : ActionType.INDIVIDUAL_CANCEL;

  const isFailed = () => {
    if (actionType === ActionType.RELEASE) {
      return (
        fetchState[DELETE_LENDING_USER_ID] !== null &&
        fetchState[DELETE_LENDING_USER_ID] === FetchStatus.FAILED
      );
    } else if (actionType === ActionType.INDIVIDUAL_CANCEL) {
      return (
        fetchState[POST_INDIVIDUAL_CANCEL] !== null &&
        fetchState[POST_INDIVIDUAL_CANCEL] === FetchStatus.FAILED
      );
    } else {
      return false;
    }
  };

  const isDisplay =
    boardState.status === BoardStatus.COMPLETION_ADD_LENDING_USER_DISP ||
    boardState.status === BoardStatus.COMPLETION_DELETE_LENDING_USER_DISP ||
    boardState.status === BoardStatus.COMPLETION_BEFORE_INDIVIDUAL_CANCEL_DISP;

  return {
    actionType: actionType,
    isDisplay: isDisplay,
    lenderDelete: boardState.lenderDelete,
    purchaseId: boardState.selectedPurchaseIdForLendingUser,
    isFailed: isFailed(),
    glossary: Glossary.instance(glState),
    alertMessage: boardState.alertMessage
  };
};

type SelectedState = ReturnType<typeof useStateProps>;

/**
 * Actionをdispatchする関数からComponentに渡すPropsへ
 */
const useMargeProps = (state: SelectedState) => {
  const dispatch = useDispatch();
  const cookie = loadCookie();
  const _token = cookie[SasCookieKeys.KEY_TOKEN];
  const _refreshToken = cookie[SasCookieKeys.KEY_REFRESH_TOKEN];
  const _purchaseId = state.purchaseId;

  const onClickClose = () => {
    // 他ユーザーの削除、プランの解約対象のインデックスが格納されているリストをクリアする
    dispatch(setDeleteIndex([]));
    dispatch(setCancelIndex([]));
    dispatch(setCheckIndex([]));
    // 第三者の利用登録情報をクリアする
    dispatch(resetLendingUser());
    // 第三者の利用登録情報を取得する
    dispatch(getLendingUserList(_token, _refreshToken, _purchaseId, false));
    dispatch(setStatus(BoardStatus.LENDING_USER_DISP));
    dispatch(setAlertMessage(''));
  };

  return {
    actionType: state.actionType,
    isDisplay: state.isDisplay,
    isFailed: state.isFailed,
    glossary: state.glossary,
    alertMessage: state.alertMessage,
    onClickClose
  };
};

export default function ContainerComponent() {
  const _props = { ...useMargeProps(useStateProps()) };
  return <CompletionBoard {..._props} />;
}
